import { Dialog, DialogContent, DialogActions } from "@material-ui/core";

import Btn from "../../buttons/Btn";
import { ModalImage, ImageContainer } from "../styles/UploadFiles";

const ModalPhoto = ({
  modalPhotoOpen,
  photo,
  setModalPhotoOpen,
  setModalPhotoContent,
}) => {
  const handleClose = () => {
    setModalPhotoContent(null);
    setModalPhotoOpen(false);
  };

  return (
    <Dialog open={modalPhotoOpen} fullWidth maxWidth="sm">
      <DialogContent>
        <ImageContainer>
          <ModalImage src={photo} />
        </ImageContainer>
      </DialogContent>
      <DialogActions>
        <Btn
          onClick={handleClose}
          bgcolor="grey"
          hovercolor="blue"
          label="Fechar"
        />
      </DialogActions>
    </Dialog>
  );
};
export default ModalPhoto;
